<script lang="ts">
	import { Button } from '@Shelly/shelly-design-system';
	import { profile_data } from 'src/stores/account/user';
	import { save_profile } from 'src/helpers/profile_helpers';

	const updateHomeData = (type) => {
		const data = $profile_data?.promotions || {};
		save_profile('promotions', {
			bluPromo: {
				...data.bluPromo,
				[type]: false,
			},
		});

		profile_data.set({
			...$profile_data,
			promotions: {
				bluPromo: {
					...data.bluPromo,
					[type]: false,
				},
			},
		});
	};

	const removePromotions = () => {
		save_profile('promotions', null);
		profile_data.set({
			...$profile_data,
			promotions: null,
		});
	};
</script>

<Button class="mb-s" icon="fas fa-dollar-sign" on:click={() => updateHomeData('basic')}
	>Reset Ble Promo Basic User modal</Button
>

<Button class="mb-s" icon="fas fa-sock" on:click={() => updateHomeData('premium')}
	>Reset Ble Promo PREMIUM User modal</Button
>

<Button icon="fas fa-sock" on:click={() => removePromotions()}>Remove all promotions</Button>
